__webpack_require__.p = "https://s.winamax.fr/pages/registration/";